import {
  ICarrierContactPerState,
  INSAContacts,
  INationalContacts,
  ISPLCContacts,
} from "../types";
import { useGetCarrierPhoneType } from "../hooks/useGetCarrierPhoneType";
import { useGetCarrierContactTypes } from "../hooks/useGetCarrierContactTypes";
import MinusButton from "../../../../components/MinusButton";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import PlusButton from "../../../../components/PlusButton";
import SelectHookFormSingle from "../../../../components/SelectHookFormSingle";
import TextInputLabelHookForm from "../../../../components/TextInputLabelHookForm";
import TextInputLabelPhone from "../../../../components/TextInputLabelPhone";
import { useEffect } from "react";
import TextInputHookFormDisabled from "../../../../components/TextInputHookFormDisabled";
import { useGetCarrierEAndOSubmissionType } from "../hooks/useGetCarrierEAndOSubmissionType";

interface CarrierContactsProps {
  carrierContacts:
    | Array<ICarrierContactPerState>
    | Array<INationalContacts>
    | Array<INSAContacts>
    | Array<ISPLCContacts>;
  showNationalFields?: boolean;
  showStateFields?: boolean;
}
const CarrierContacts = ({
  carrierContacts,
  showNationalFields = false,
  showStateFields = false,
}: CarrierContactsProps): JSX.Element => {
  const useFormMethods = useFormContext();
  const {
    control,
    formState: { errors },
    register,
    watch,
    setValue,
  } = useFormMethods;
  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: carrierContacts[0]?.tableName ?? "",
  });
  const tableArray = watch(`${carrierContacts[0]?.tableName}`);
  const controlledFields =
    tableArray &&
    fields.map((field, index) => ({
      ...field,
      ...tableArray[index],
    }));
  //SETTING DEFAULT TABLE VALUES
  useEffect(() => {
    if (carrierContacts) {
      replace(carrierContacts);
    }
  }, [carrierContacts]);

  //For Dropdown Options
  const { data: carrierContactType, isLoading: getContactTypeLoading } =
    useGetCarrierContactTypes();

  const nationalContactTypeOptions = carrierContactType?.map((contacttype) => {
    return {
      label: contacttype.contactTypeName,
      value: contacttype.contactTypeId,
    };
  });

  const contactTypeOptions = carrierContactType
    ?.filter((contacttype) => contacttype.contactTypeName !== "E&O")
    .map((contacttype) => ({
      label: contacttype.contactTypeName,
      value: contacttype.contactTypeId,
    }));

  const { data: phoneTypeOpt } = useGetCarrierPhoneType();

  const phoneOpt = phoneTypeOpt?.map((x) => {
    return {
      label: x.phoneTypeName,
      value: x.phoneTypeId,
    };
  });

  const { data: eAndOSubmissionTypeOpt } = useGetCarrierEAndOSubmissionType();

  const eAndOSubmissionOpt = eAndOSubmissionTypeOpt?.map((x) => {
    return {
      label: x.carrierEandOsubmissionTypeName,
      value: x.carrierEandOsubmissionTypeId,
    };
  });

  return (
    <>
      {controlledFields &&
        controlledFields.map((field, index) => {
          const contactTypeValue = watch(
            `${carrierContacts[0]?.tableName}[${index}].contactType`
          );

          const contactTypeLabel =
            nationalContactTypeOptions?.find(
              (option) => option.value === contactTypeValue
            )?.label ?? "";

          const EAndOValue = watch(
            `${carrierContacts[0]?.tableName}[${index}].eAndOId`
          );

          const EAndOLabel =
            eAndOSubmissionOpt?.find((option) => option.value === EAndOValue)
              ?.label ?? "";

          return (
            <div className="grid sm:grid-cols-10 py-1 pr-2 " key={field.id}>
              <div className="col-span-1 grid sm:grid-cols-2 px-2 ">
                <div
                  className={`col-span-1 self-center w-1/2 ml-5 ${
                    index < 1 &&
                    carrierContacts[0]?.parentRow === true &&
                    "mt-4"
                  }`}
                >
                  {index > 0 ? (
                    <MinusButton type="button" onClick={() => remove(index)} />
                  ) : (
                    <PlusButton
                      type="button"
                      onClick={(e) =>
                        append({
                          tableName: carrierContacts[0]?.tableName,
                          parentRow: false,
                        })
                      }
                    />
                  )}
                </div>
                {carrierContacts[0]?.tableName?.includes("contactState") && (
                  <div className="col-span-1 ">
                    <div
                      className={`grid grid-cols-1 w-full items-center gap-1 text-xs`}
                    >
                      {index < 1 && carrierContacts[0]?.parentRow === true && (
                        <label className="flex space-x-1 justify-start expandedLabel fontExpand">
                          State
                        </label>
                      )}

                      <TextInputHookFormDisabled
                        type="text"
                        register={register(
                          `${carrierContacts[0]?.tableName}[${0}].stateCode`,
                          {}
                        )}
                        className="font-bold"
                      />
                    </div>
                  </div>
                )}
              </div>

              <div className="col-span-9 grid sm:grid-cols-8 content-center gap-x-2 h-16">
                <Controller
                  control={control}
                  name={`${carrierContacts[0]?.tableName}[${index}].contactType`}
                  render={({ field }) => (
                    <SelectHookFormSingle
                      label={
                        index < 1 && carrierContacts[0]?.parentRow === true
                          ? "Contact Type"
                          : undefined
                      }
                      field={field}
                      onChange={(e) => {
                        const newValue = e ? e.value : null;
                        field.onChange(newValue);

                        if (newValue !== "E&O") {
                          setValue(
                            `${carrierContacts[0]?.tableName}[${index}].eAndOId`,
                            null
                          );
                        }
                      }}
                      value={field.value ? field.value : null}
                      options={
                        showNationalFields || showStateFields
                          ? nationalContactTypeOptions
                          : contactTypeOptions
                      }
                      isLoading={getContactTypeLoading}
                      className={
                        errors?.[carrierContacts[0]?.tableName ?? ""]?.[index]
                          ?.contactType && "border-2 border-red-500 col-span-2"
                      }
                      secondDiv={
                        index < 1 && carrierContacts[0]?.parentRow === true
                          ? "grid grid-cols-1"
                          : ""
                      }
                    />
                  )}
                />

                {(showNationalFields || showStateFields) && (
                  <Controller
                    control={control}
                    name={`${carrierContacts[0]?.tableName}[${index}].eAndOId`}
                    rules={{
                      required: false,
                    }}
                    render={({ field }) => (
                      <SelectHookFormSingle
                        label={
                          index < 1 && carrierContacts[0]?.parentRow === true
                            ? "E&O Submission Type"
                            : undefined
                        }
                        field={field}
                        onChange={(e) => {
                          field.onChange(e ? e.value : null);
                        }}
                        value={
                          contactTypeLabel === "E&O"
                            ? field.value ?? null
                            : null
                        }
                        options={eAndOSubmissionOpt}
                        isLoading={false}
                        required={false}
                        secondDiv={
                          index < 1 && carrierContacts[0]?.parentRow === true
                            ? "grid grid-cols-1"
                            : ""
                        }
                        className={
                          errors?.[carrierContacts[0]?.tableName ?? ""]?.[index]
                            ?.eAndOId && "border-2 border-red-500 col-span-1"
                        }
                        isDisabled={contactTypeLabel !== "E&O"}
                      />
                    )}
                  />
                )}
                <TextInputLabelHookForm
                  label={
                    index < 1 && carrierContacts[0]?.parentRow === true
                      ? "Contact Name"
                      : undefined
                  }
                  type="text"
                  required={
                    !!watch(
                      `${carrierContacts[0]?.tableName}[${index}].contactType`
                    )
                  }
                  className={
                    errors?.[carrierContacts[0]?.tableName ?? ""]?.[index]
                      ?.name && "border-2 border-red-500 col-span-2"
                  }
                  register={register(
                    `${carrierContacts[0]?.tableName}[${index}].name`,
                    {
                      required: {
                        value: !!watch(
                          `${carrierContacts[0]?.tableName}[${index}].contactType`
                        ),
                        message: "Required Field",
                      },
                    }
                  )}
                  secondDiv={
                    index < 1 && carrierContacts[0]?.parentRow === true
                      ? "grid grid-cols-1"
                      : ""
                  }
                />
                <TextInputLabelHookForm
                  label={
                    index < 1 && carrierContacts[0]?.parentRow === true
                      ? "Contact Email"
                      : undefined
                  }
                  type="text"
                  register={register(
                    `${carrierContacts[0]?.tableName}[${index}].email`,
                    {
                      required:
                        EAndOLabel === "Email" && contactTypeLabel === "E&O"
                          ? "Email is required"
                          : false,
                      pattern: {
                        value: /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/,
                        message: "Invalid email format",
                      },
                    }
                  )}
                  pattern="[^@]+@[^@]+\.[a-zA-Z]{2,}"
                  title="Format: emailname@emaildomain.com"
                  placeholder="emailname@emaildomain.com"
                  secondDiv={
                    index < 1 && carrierContacts[0]?.parentRow === true
                      ? "grid grid-cols-1"
                      : ""
                  }
                  required={
                    EAndOLabel === "Email" && contactTypeLabel === "E&O"
                  }
                  className={
                    errors?.[carrierContacts[0]?.tableName ?? ""]?.[index]
                      ?.email && "border-2 border-red-500 col-span-2"
                  }
                />

                {(showNationalFields || showStateFields) && (
                  <div className="col-span-1">
                    <TextInputLabelHookForm
                      label={
                        index < 1 && carrierContacts[0]?.parentRow === true
                          ? "URL"
                          : undefined
                      }
                      type="text"
                      register={register(
                        `${carrierContacts[0]?.tableName}[${index}].url`,
                        {
                          required:
                            EAndOLabel === "Online" &&
                            contactTypeLabel === "E&O"
                              ? "URL is required"
                              : false,

                          pattern: {
                            value: /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}$/i,
                            message: "Invalid URL format",
                          },
                        }
                      )}
                      placeholder="https://www.example.com"
                      secondDiv={
                        index < 1 && carrierContacts[0]?.parentRow === true
                          ? "grid grid-cols-1"
                          : ""
                      }
                      required={
                        EAndOLabel === "Online" && contactTypeLabel === "E&O"
                      }
                      className={
                        errors?.[carrierContacts[0]?.tableName ?? ""]?.[index]
                          ?.url && "border-2 border-red-500 col-span-2"
                      }
                    />
                  </div>
                )}
                <Controller
                  control={control}
                  name={`${carrierContacts[0]?.tableName}[${index}].phoneTypeId`}
                  rules={{
                    required: !!watch(
                      `${carrierContacts[0]?.tableName}[${index}].contactNumber`
                    ),
                  }}
                  render={({ field }) => (
                    <SelectHookFormSingle
                      label={
                        index < 1 && carrierContacts[0]?.parentRow === true
                          ? "Phone Type"
                          : undefined
                      }
                      field={field}
                      onChange={(e) => {
                        field.onChange(e ? e.value : null);
                      }}
                      value={field.value ? field.value : null}
                      options={phoneOpt}
                      isLoading={false}
                      required={
                        !!watch(
                          `${carrierContacts[0]?.tableName}[${index}].contactNumber`
                        )
                      }
                      secondDiv={
                        index < 1 && carrierContacts[0]?.parentRow === true
                          ? "grid grid-cols-1"
                          : ""
                      }
                      className={
                        errors?.[carrierContacts[0]?.tableName ?? ""]?.[index]
                          ?.phoneTypeId && "border-2 border-red-500 col-span-2"
                      }
                      isDisabled={
                        !watch(
                          `${carrierContacts[0]?.tableName}[${index}].contactType`
                        )
                      }
                    />
                  )}
                />
                <TextInputLabelPhone
                  label={
                    index < 1 && carrierContacts[0]?.parentRow === true
                      ? "Phone Number"
                      : undefined
                  }
                  type="number"
                  register={register(
                    `${carrierContacts[0]?.tableName}[${index}].contactNumber`,
                    {
                      required: !!watch(
                        `${carrierContacts[0]?.tableName}[${index}].phoneTypeId`
                      ),
                    }
                  )}
                  disabled={
                    !watch(
                      `${carrierContacts[0]?.tableName}[${index}].phoneTypeId`
                    )
                  }
                  pattern="(\(\d{3}\)) \d{3}[-]\d{4}"
                  title="Format: (000) 000-0000"
                  placeholder="(000) 000-0000"
                  onChange={(e) => {
                    if (e.target.value) {
                      var x = e.target.value
                        .replace(/\D/g, "")
                        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                      if (x) {
                        e.target.value = !x[2]
                          ? x[1]
                          : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
                      }
                    } else {
                      setValue(
                        `${carrierContacts[0]?.tableName}[${index}].contactNumber`,
                        ""
                      );
                    }
                  }}
                  required={
                    !!watch(
                      `${carrierContacts[0]?.tableName}[${index}].phoneTypeId`
                    )
                  }
                  className={
                    errors?.[carrierContacts[0]?.tableName ?? ""]?.[index]
                      ?.contactNumber && "border-2 border-red-500 col-span-2"
                  }
                  secondDiv={
                    index < 1 && carrierContacts[0]?.parentRow === true
                      ? "grid grid-cols-1"
                      : ""
                  }
                />

                <TextInputLabelPhone
                  label={
                    index < 1 && carrierContacts[0]?.parentRow === true
                      ? "Extension No."
                      : undefined
                  }
                  type="number"
                  register={register(
                    `${carrierContacts[0]?.tableName}[${index}].extensionNumber`,
                    {}
                  )}
                  placeholder="00000"
                  pattern="^\d{0,5}$"
                  title="Format: 12345"
                  disabled={
                    !watch(
                      `${carrierContacts[0]?.tableName}[${index}].phoneTypeId`
                    )
                  }
                  onChange={(e) => {
                    if (e.target.value) {
                      var x = e.target.value.replace(/\D/g, "").match(/\d{5}/);
                      if (x) {
                        e.target.value = x.toString();
                      }
                    } else {
                      setValue(
                        `${carrierContacts[0]?.tableName}[${index}].extensionNumber`,
                        null
                      );
                    }
                  }}
                  secondDiv={
                    index < 1 && carrierContacts[0]?.parentRow === true
                      ? "grid grid-cols-1"
                      : ""
                  }
                />
              </div>
            </div>
          );
        })}
    </>
  );
};

export default CarrierContacts;
